var map = {
	"./de": [
		"bac1",
		"lang-de"
	],
	"./de.json": [
		"bac1",
		"lang-de"
	],
	"./en": [
		"e312"
	],
	"./en.json": [
		"e312"
	],
	"./es": [
		"ef52",
		"lang-es"
	],
	"./es.json": [
		"ef52",
		"lang-es"
	],
	"./fr": [
		"b16e",
		"lang-fr"
	],
	"./fr.json": [
		"b16e",
		"lang-fr"
	],
	"./it": [
		"669f",
		"lang-it"
	],
	"./it.json": [
		"669f",
		"lang-it"
	],
	"./zh": [
		"799d",
		"lang-zh"
	],
	"./zh-CN": [
		"6366",
		"lang-zh-CN"
	],
	"./zh-CN.json": [
		"6366",
		"lang-zh-CN"
	],
	"./zh.json": [
		"799d",
		"lang-zh"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5892";
module.exports = webpackAsyncContext;